/**
 * Typed cache keys for the providers feature.
 *
 * Per ADR-0012: query keys are typed constants, never inline string arrays.
 */
export const providersKeys = {
	all: ['providers'] as const,
	list: () => ['providers'] as const,
	detail: (providerId: string) => ['providers', providerId] as const,
}
